import React, { useEffect, useState } from "react";
import { PaymentOptionsType } from "../../../../commonTypes/clientSettingsTypes";
import { TrashIcon, UploadNew } from "../../../Icon";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../../assets/images";
import { BankAccountInfoType } from "../../../../redux/services/serviceTypes";
import { BusinessAddressListType } from "../../../../redux/clientSettings/clientSettingTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  handleToggleUploadFileModal: (data: any) => void;
  handleDeleteUploadedFile: (data: any) => void;
  getBankDetails: (data: any) => void;
  upiFile: any;
  setPaymentDetails: React.Dispatch<React.SetStateAction<any>>;
  paymentDetails: PaymentOptionsType;
  bankAccountDetails: BankAccountInfoType | null;
  businessAddressData: BusinessAddressListType | any;
  servicesError: string | null;
};

const PaymentsDetails = ({
  setPaymentDetails,
  paymentDetails,
  handleToggleUploadFileModal,
  handleDeleteUploadedFile,
  upiFile,
  getBankDetails,
  bankAccountDetails,
  businessAddressData,
  servicesError,
}: AppProps) => {
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    if (bankAccountDetails?.name_at_bank) {
      setPaymentDetails((prv: PaymentOptionsType) => {
        return {
          ...prv,
          bank_details: {
            ...prv.bank_details,
            beneficiary_name: bankAccountDetails?.name_at_bank,
          },
        };
      });
    } else {
      setPaymentDetails((prv: PaymentOptionsType) => {
        return {
          ...prv,
          bank_details: {
            ...prv.bank_details,
            beneficiary_name: "",
          },
        };
      });
    }
  }, [bankAccountDetails]);
  useEffect(() => {
    if (servicesError?.length) {
      setPaymentDetails((prv: any) => {
        return {
          ...prv,
          bank_details: {
            ...prv.bank_details,
            ifscError: servicesError,
          },
        };
      });
    } else {
      setPaymentDetails((prv: any) => {
        return {
          ...prv,
          bank_details: {
            ...prv.bank_details,
            ifscError: "",
          },
        };
      });
    }
  }, [servicesError]);

  const handleDownload = async (fileUrl: string, fileName: string) => {
    const response = await fetch(`${blobBaseUrl}${fileUrl}?${blobToken}`);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName || "downloaded_file"; 
    document.body.appendChild(a);
    a.click();
    a.remove();

    window.URL.revokeObjectURL(url);
 
};
  const handlePaymentDetailsChange = (e: any) => {
    if (e.target.name === "ifsc_code" || e.target.name === "account_no") {
      setPaymentDetails((prv: any) => {
        return {
          ...prv,
          bank_details: {
            ...prv.bank_details,
            [e.target.name]: e.target.value,
            ifscError: "",
          },
        };
      });
    } else {
      setPaymentDetails((prv: any) => {
        return {
          ...prv,
          bank_details: {
            ...prv.bank_details,
            [e.target.name]: e.target.value,
          },
        };
      });
    }
  };

  const handleUpiPaymentDetailsChange = (e: any) => {
    setPaymentDetails((prv: PaymentOptionsType) => {
      return {
        ...prv,
        upi_details: {
          ...prv.upi_details,
          [e.target.name]: e.target.value,
        },
      };
    });
  };

  return (
    <>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Ifsc Code">Ifsc Code</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="ifsc_code"
                  value={paymentDetails?.bank_details?.ifsc_code}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
              </div>
              {paymentDetails?.bank_details?.ifscError?.includes(
                "Invalid IFSC"
              ) ? (
                <span className="text-danger">
                  {paymentDetails?.bank_details?.ifscError}
                </span>
              ) : null}
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div className="position-relative">
                <label htmlFor="Account No">Account Number</label>
                <input
                  type="number"
                  className={`form-control`}
                  name="account_no"
                  value={paymentDetails?.bank_details?.account_no}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
                <span
                  className="position-absolute"
                  style={{ top: "30px", right: "5px" }}
                >
                  {(!paymentDetails?.bank_details?.ifscError &&
                    bankAccountDetails?.account_exists === "Yes" &&
                    paymentDetails?.bank_details?.account_no) ||
                  (!paymentDetails?.bank_details?.ifscError &&
                    businessAddressData &&
                    businessAddressData?.payment_details?.verifyBankDetails
                      ?.account_exists === "Yes" &&
                    businessAddressData?.payment_details?.bank_details
                      ?.account_no ===
                      paymentDetails?.bank_details?.account_no &&
                    businessAddressData?.payment_details?.bank_details
                      ?.ifsc_code ===
                      paymentDetails?.bank_details?.ifsc_code) ? (
                    <OverlayTrigger
                      placement="top"
                      delay={{ show: 250, hide: 250 }}
                      overlay={
                        <Tooltip id="button-view-filter-invoice">
                          <div>
                            <div className="text-left">
                              Name at bank :{" "}
                              {bankAccountDetails?.name_at_bank
                                ? bankAccountDetails?.name_at_bank
                                : businessAddressData?.payment_details
                                    ?.verifyBankDetails?.name_at_bank
                                ? businessAddressData?.payment_details
                                    ?.verifyBankDetails?.name_at_bank
                                : "NA"}
                            </div>
                            <div className="text-left">
                              Account Exists :{" "}
                              {bankAccountDetails?.account_exists
                                ? bankAccountDetails?.account_exists
                                : businessAddressData?.payment_details
                                    ?.verifyBankDetails?.account_exists
                                ? businessAddressData?.payment_details
                                    ?.verifyBankDetails?.account_exists
                                : "NA"}
                            </div>
                          </div>
                        </Tooltip>
                      }
                    >
                      <img src={EnableiIcon} />
                    </OverlayTrigger>
                  ) : (
                    <img src={DisableiIcon} />
                  )}
                </span>
              </div>
              {(!paymentDetails?.bank_details?.ifscError &&
                bankAccountDetails?.account_exists === "Yes") ||
              (!paymentDetails?.bank_details?.ifscError &&
                businessAddressData &&
                businessAddressData?.payment_details?.verifyBankDetails
                  ?.account_exists === "Yes" &&
                businessAddressData?.payment_details?.bank_details
                  ?.account_no === paymentDetails?.bank_details?.account_no &&
                businessAddressData?.payment_details?.bank_details
                  ?.ifsc_code === paymentDetails?.bank_details?.ifsc_code) ? (
                <span>
                  <img src={VerifyIcon} alt="pan" />{" "}
                  <span style={{ color: "#28a745" }}>
                    Bank Details is Verified
                  </span>
                </span>
              ) : bankAccountDetails?.account_exists === "NO" ||
                businessAddressData?.payment_details?.verifyBankDetails
                  ?.account_exists === "NO" ? (
                <span className="text-danger">
                  {bankAccountDetails?.message ||
                    businessAddressData?.payment_details?.verifyBankDetails
                      ?.message}
                </span>
              ) : null}
            </div>
          </form>
        </div>
        <div className="col-md-2">
          <div className="form-group" style={{ marginTop: "38px" }}>
            <button
              className="btn btn-outline"
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              disabled={
                !paymentDetails?.bank_details?.account_no ||
                !paymentDetails?.bank_details?.ifsc_code
              }
              onClick={(e) => {
                getBankDetails(e);
              }}
            >
              <img
                src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                alt="check"
              />{" "}
              <span>Verify</span>
            </button>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Beneficiary Name">Beneficiary Name</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="beneficiary_name"
                  disabled={!!bankAccountDetails?.name_at_bank}
                  value={paymentDetails?.bank_details?.beneficiary_name}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label htmlFor="Bank Name">Bank Name</label>
                <input
                  type="text"
                  className={`form-control`}
                  name="bank_name"
                  value={paymentDetails?.bank_details?.bank_name}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Swift Code"
                  // className={professionalTaxEmployer ? "active" : ""}
                >
                  Swift Code
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="swift_code"
                  value={paymentDetails?.bank_details?.swift_code}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="Bank Branch Address"
                  // className={professionalTaxEmpoyee ? "active" : ""}
                >
                  Bank Branch Address
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="bank_branch_address"
                  value={paymentDetails?.bank_details?.bank_branch_address}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
              </div>
            </div>
          </form>
        </div>
        <div className="col-md-3">
          <form>
            <div className="form-group mt-3">
              <div>
                <label
                  htmlFor="city"
                  // className={udyogAadhar ? "active" : ""}
                >
                  City
                </label>
                <input
                  type="text"
                  className={`form-control`}
                  name="city"
                  value={paymentDetails?.bank_details?.city}
                  onChange={(e) => handlePaymentDetailsChange(e)}
                />
              </div>
              {/* <span className="input-length">{returnInputFieldLength(udyogAadhar?.length, 12)}</span> */}
            </div>
          </form>
        </div>
      </div>
      <div className="row">
        <div className="col-md-10">
          <form>
            <div className="form-group mt-3">
              <div>
                <h4>UPI Details</h4>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <label htmlFor="upiId">UPI ID</label>
                  <input
                    type="text"
                    className={`form-control`}
                    name="upi_id"
                    value={paymentDetails?.upi_details?.upi_id}
                    onChange={(e) => handleUpiPaymentDetailsChange(e)}
                  />
                </div>

                <div className="col-md-4 mt-3">
                  {/* <label htmlFor="fileUpload">Upload QR</label> */}
                  {upiFile && Object.keys(upiFile).length ? (
                    <div className="pointer d-flex flex-row mt-2">
                      <a
                        // href={
                        //   upiFile?.file_url
                        //     ? `${blobBaseUrl}${upiFile?.file_url}?${blobToken}`
                        //     : ""
                        // }
                        onClick={() =>
                          handleDownload(upiFile?.file_url, upiFile?.file_name)
                        }
                        target="_blank"
                        className="uploaded_file_name"
                      >
                        {upiFile?.file_name}
                      </a>
                      <div className="ml-2" onClick={handleDeleteUploadedFile}>
                        <TrashIcon />
                      </div>
                    </div>
                  ) : (
                    <button
                      className="btn btn-sm btn-outline mt-2 w-50"
                      value={paymentDetails?.upi_details?.upi_image?.file_name}
                      onClick={(e: any) => handleToggleUploadFileModal(e)}
                    >
                      <span>
                        <UploadNew /> Upload QR
                      </span>
                    </button>
                  )}
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default PaymentsDetails;
